export const CERTIFICATES_EMPTY_NAME = 'Без названия';
export const CERTIFICATES_DEFAULT_PAGE_SIZE = 20;

// Сумма ширин колонок (320 + 160 + 100) плюс ~8% запаса
export const CERTIFICATES_TABLE_SCROLL_X = 630;
